import React from "react";
import HealthFields from "./HealthFields";
import LifeFields from "./LifeFields";
import MotorFields from "./MotorFields";
import PersonalAccidentFields from "./PersonalAccidentFields";
import CriticalIllnessFields from "./CriticalIllnessFields";
import TravelFields from "./TravelFields";
import HomePropertyFields from "./HomePropertyFields";
import OtherFields from "./OtherFields";

interface TypeSpecificSectionProps {
  insuranceType: string;
  data: Record<string, any>;
  onChange: (data: Record<string, any>) => void;
}

const COMPONENT_MAP: Record<
  string,
  React.FC<{ data: Record<string, any>; onChange: (d: Record<string, any>) => void }>
> = {
  health: HealthFields,
  life: LifeFields,
  motor: MotorFields,
  personal_accident: PersonalAccidentFields,
  critical_illness: CriticalIllnessFields,
  travel: TravelFields,
  home_property: HomePropertyFields,
  other: OtherFields,
};

const TYPE_LABELS: Record<string, string> = {
  health: "Health Insurance",
  life: "Life Insurance",
  motor: "Motor/Vehicle Insurance",
  personal_accident: "Personal Accident",
  critical_illness: "Critical Illness",
  travel: "Travel Insurance",
  home_property: "Home/Property Insurance",
  other: "Other Insurance",
};

const TypeSpecificSection: React.FC<TypeSpecificSectionProps> = ({
  insuranceType,
  data,
  onChange,
}) => {
  const Component = COMPONENT_MAP[insuranceType];

  if (!Component) return null;

  return (
    <div className="irf-section">
      <h3 className="irf-section-label">
        {TYPE_LABELS[insuranceType] || "Insurance"} — Additional Details
      </h3>
      <p className="irf-section-hint">
        Fill in type-specific details for your {TYPE_LABELS[insuranceType]?.toLowerCase() || "insurance"} policy (all optional).
      </p>
      <Component data={data} onChange={onChange} />
    </div>
  );
};

export default TypeSpecificSection;
